import { useContext } from "react";

import { ToastsContext } from "./ToastsContext";

export function useToasts() {
  const context = useContext(ToastsContext);
  if (!context) {
    throw new Error("useToasts must be used within a ToastsProvider");
  }
  return context;
}
